import React from 'react';
import { Link } from 'react-router-dom';
import Avatar from '../ui/Avatar';
import { PriorityBadge, StatusBadge } from '../ui/Badge';

const formatDate = (value) =>
    value ? new Date(value).toLocaleDateString(undefined, { day: '2-digit', month: 'short' }) : null;

const TaskCard = ({ task }) => (
    <Link
        to={`/tasks/${task.id}`}
        className="block bg-white border border-[var(--border-color)] rounded-md p-3 hover:border-[var(--border-strong)] hover:shadow-xs transition-all duration-150"
    >
        <div className="flex items-start justify-between gap-2">
            <h4 className="text-base font-medium text-ink-900 line-clamp-1">{task.title}</h4>
            {task.task_code && (
                <span className="text-micro font-mono text-ink-500 shrink-0">{task.task_code}</span>
            )}
        </div>

        {task.description && (
            <p className="text-label text-ink-500 line-clamp-2 mt-1">{task.description}</p>
        )}

        <div className="flex items-center gap-2 mt-2.5">
            <PriorityBadge priority={task.priority} />
            <StatusBadge status={task.status} />
            <span className="ml-auto flex items-center gap-2 text-micro text-ink-500 tabular">
                {formatDate(task.due_date)}
                {task.assignee_name && <Avatar name={task.assignee_name} size="xs" />}
            </span>
        </div>
    </Link>
);

export default TaskCard;
